import type { AppConfigInput } from '@nuxt/schema'

export default {
  card: {
    slots: {
      root: 'w-full',
    },
    variants: {
      variant: {
        product: {
          root: 'text-xs flex flex-col',
          body: 'p-0 m-0 sm:p-0 sm:m-0 flex-1',
          footer: 'p-0 pt-1 m-0 sm:p-0 sm:pt-1 sm:m-0',
        },
      },
    },
  },
} as AppConfigInput['ui']
